export default {"src":"/_next/static/media/gardesbenevoles.0ff8c821.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};